import React from 'react'
function TopRatedApp() {
    return (
        <>
            <div className="weworkfor pt20 pb20 dark-bg2">
                <div className="container">
                    <div className="logo-weworkfor owl-carousel">
                        <div className="items"><img src="https://images.unsplash.com/photo-1681239063386-fc4a373c927b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw2NXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60" alt="niwax html template" className="img100w" />
                        </div>
                        <div className="items"><img src="https://images.unsplash.com/photo-1681239063386-fc4a373c927b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw2NXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60" alt="niwax html template" className="img100w" />
                        </div>
                        <div className="items"><img src="https://images.unsplash.com/photo-1681239063386-fc4a373c927b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw2NXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60" alt="niwax html template" className="img100w" />
                        </div>
                        <div className="items"><img src="https://images.unsplash.com/photo-1681239063386-fc4a373c927b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw2NXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60" alt="niwax html template" className="img100w" />
                        </div>
                        <div className="items"><img src="https://images.unsplash.com/photo-1681239063386-fc4a373c927b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw2NXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60" alt="niwax html template" className="img100w" />
                        </div>
                        <div className="items"><img src="https://images.unsplash.com/photo-1681239063386-fc4a373c927b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw2NXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60" alt="niwax html template" className="img100w" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TopRatedApp